export default "__VITE_ASSET__DnwvsgEe__"